$(document).ready(function() {

    $("input[type='checkbox'].js-select-line").on('click',function() {
        
        var parent = $(this).parents('tr');
        var countChecked = $("input[type='checkbox'].js-select-line:checked").length;

        $(".account__return-instructions-title span").html(countChecked);
        
        if($(this).is(":checked")) {
            parent.find("td").not(':first').removeClass('disabled');
            parent.find("td textarea").prop('disabled', false);
            parent.find("td select").prop('disabled', false);
            parent.find("td").css('pointer-events','all');
        } else {
            parent.find("td").not(':first').addClass('disabled');
            parent.find("td textarea").prop('disabled', true);
            parent.find("td select").prop('disabled', true);
            parent.find("td.disabled").css('pointer-events','none');
        }
    });

    $('select.js-reason-change').on('change', function() {
      if(this.value == 'Other') {
        $(this).next().next('.return_reason_wrap').show();
      } else {
        $(this).next().next('.return_reason_wrap').hide();
      }
    });

    $('form[name="returns_form"]').validate({
        ignore: [],
        messages: {
          return_reason: "Please enter a reason for each product being returned."
        },
        focusInvalid: false,
        invalidHandler: function(form, validator) {
          if (!validator.numberOfInvalids())
            return;
          swal({
            title: '',
            type: 'error',
            text: 'Your return could not be submitted. Please double check you have entered all the required fields.',
            confirmButtonColor: "#f15a24"
          });
        },
        submitHandler: function() {
          $('.account__return-instructions').append('<img class="loading" src="' + $(document.body).data('base') + '/images/site/loading.gif">');
          $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/returns/submit-return.php',
            data: $('form[name="returns_form"]').serialize(),
            success: function(response) {
                $('.account__return-instructions').find('.loading').remove();
                response = JSON.parse(response);
                swal({
                  title:'',
                  text: response.message,
                  type: response.status.toLowerCase(),
                  confirmButtonColor: "#f15a24"
                }, function() {
                  if(response.status == 'SUCCESS') {
                    location.reload();
                  }
                });
            },
            error: function() {
                console.log('Ajax request not received');
            }
          });
      
          return false;
        }
      });

});